export default __webpack_public_path__ + "af6e1243003c72f2a86e9a840d411ab6.webp";